if (!customElements.get('ma-review-list')) {
  customElements.define('ma-review-list', class extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;
        this.list = this.querySelector('.ma-reviews__list');
        this.items = Array.from(this.list.children);
        for (let i = this.items.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [this.items[i], this.items[j]] = [this.items[j], this.items[i]];
        }
        this.items.forEach(item => this.list.appendChild(item));
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        this.status = this.querySelector('[role="status"]');
        this.navigation = this.querySelector('.ma-reviews__navigation');
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.list.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true });
        this.list.addEventListener('keydown', event => {
          if (event.target !== this.list) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            this.move(this.isRtl() ? -direction : direction);
          }
        });
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
      }
      this.observer.observe(this.list);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.statusTimer);
    }

    isRtl() {
      return getComputedStyle(this.list).direction === 'rtl';
    }

    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }

    update() {
      const max = this.list.scrollWidth - this.list.clientWidth;
      const position = Math.abs(this.list.scrollLeft);
      this.navigation.hidden = max <= 2;
      this.previous.disabled = position <= 2;
      this.next.disabled = position >= max - 2;
      const bounds = this.list.getBoundingClientRect();
      const visible = this.items.map((item, index) => ({ bounds: item.getBoundingClientRect(), index }))
        .filter(item => item.bounds.right > bounds.left + 2 && item.bounds.left < bounds.right - 2);
      clearTimeout(this.statusTimer);
      // Wait for scrolling to settle before announcing the visible range.
      this.statusTimer = setTimeout(() => {
        if (visible.length) this.status.textContent = `${visible[0].index + 1}–${visible.at(-1).index + 1} de ${this.items.length}`;
      }, 150);
    }

    move(direction) {
      if (!this.items.length) return;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      const step = this.items[0].getBoundingClientRect().width + gap;
      const position = Math.abs(this.list.scrollLeft);
      const target = (Math.round(position / step) + direction) * step;
      this.list.scrollTo({
        left: (this.isRtl() ? -1 : 1) * target,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
  });
}
